import PostImagePoll from "./PostImagePoll";
import PostLink from "./PostLink";
import PostMedia1 from "./PostMedia1";
import PostMedia2 from "./PostMedia2";
import PostMedia3 from "./PostMedia3";
import PostMedia4 from "./PostMedia4";
import PostMedia5 from "./PostMedia5";
import PostMedia6 from "./PostMedia6";
import PostTextPoll from "./PostTextPoll";

export type MediaTypeProps = {
    mediaType: number;
};
const MediaType = ({ mediaType }: MediaTypeProps) => {
    return (
        <>
            {mediaType ? (
                <>
                    {mediaType == 1 ? (
                        <PostMedia1 />
                    ) : mediaType == 2 ? (
                        <PostMedia2 />
                    ) : mediaType == 3 ? (
                        <PostMedia3 />
                    ) : mediaType == 4 ? (
                        <PostMedia4 />
                    ) : mediaType == 5 ? (
                        <PostMedia5 />
                    ) : mediaType == 6 ? (
                        <PostMedia6 />
                    ) : mediaType == 7 ? (
                        <PostImagePoll />
                    ) : mediaType == 8 ? (
                        <PostTextPoll />
                    ) : mediaType == 9 ? (
                        <PostLink />
                    ) : (
                        ""
                    )}
                </>
            ) : (
                ""
            )}
        </>
    );
};

export default MediaType;
